import MomentUtils from '@date-io/moment';
import Framework, { LoadingHandler, StateErrorDisplay, shapes } from '@greenville/framework';
import { Box, Button, Grid, Paper, TextField, Typography } from '@material-ui/core';
import { ThemeProvider, createTheme, withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import axios from 'axios';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
// import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import * as _ from 'lodash';
import { toJS } from 'mobx';
import AutocompleteComponent from '../common/components/Autocomplete';
import ChatDataGrid from './datagrid/ChatDataGrid';
// import ChatgptUtilityModel from '../models/ChatgptUtility';
import FeedbackModel from '../models/Feedback';
import McqSearch from '../models/McqSearch';
// import ResponseModel from '../models/Response';
import Loader from '../../../common/Loader';
import ChatgptConfig from '../../../common/config/ChatgptConfig';
import * as constants from '../../../common/constants';
import env from '../../../common/env';
import utils from '../../../common/utils';
import InternalUsersList from '../models/InternalUsersList';
import CDNToken from '../models/CDNToken';

const materialTheme = createTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: constants.PEARSON_PRIMARY_COLOR
      }
    },
    MuiPickersYear: {
      root: {
        '&:hover': {
          backgroundColor: '#d2cfc4'
        }
      },
      yearSelected: {
        color: constants.PEARSON_PRIMARY_COLOR
      },
      current: {
        color: constants.PEARSON_PRIMARY_COLOR
      }
    },
    MuiPickersDay: {
      day: {
        '&:hover': {
          backgroundColor: '#d2cfc4'
        }
      },
      daySelected: {
        backgroundColor: constants.PEARSON_PRIMARY_COLOR,
        '&:hover': {
          backgroundColor: constants.PEARSON_PRIMARY_COLOR
        }
      },
      current: {
        color: constants.PEARSON_PRIMARY_COLOR
      }
    }
  }
});

const themes = createTheme({
  palette: {
    primary: {
      light: '#047a9c',
      main: '#005d83',
      dark: '#003558',
      contrastText: '#ffffff'
    }
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 30
      }
    }
  }
});

const styles = (theme) => ({
  datePicker: {
    marginTop: 'inherit'
    // width: '49%'
  },
  buttonGroupStyle: {
    justifyContent: 'center'
  },
  blurStyle: {
    position: 'absolute',
    background: 'rgb(255 255 255 / 20%)',
    top: '0',
    width: '93%',
    height: '100%',
    backdropFilter: 'blur(0.3px)',
    zIndex: '9999'
  },
  buttonStyle: {
    width: '120px',
    margin: '10px'
  },
  container: {
    marginBottom: 20
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary
  },
  title: {
    marginTop: -20
  },
  labelWidht: {
    width: '380px'
  },
  boxWidth: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(4)
  },
  button: {
    paddingTop: theme.spacing(2),
    marginBottom: '-3em'
  },
  root: {
    top: '12%'
  },
  msgStyle: {
    fontSize: 'large',
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(0)
    },
    zIndex: 9999
  }
});

@inject('chatgptFeedbackUtility', 'chatgptUtilityFeedbackStatus', 'mcqSearch', 'internalUsers', 'cdnToken')
@observer
class ChatGptUtilityFeeback extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    chatgptFeedbackUtility: shapes.modelOf(FeedbackModel).isRequired,
    chatgptUtilityFeedbackStatus: shapes.state.isRequired,
    mcqSearch: shapes.modelOf(McqSearch).isRequired,
    internalUsers: shapes.modelOf(InternalUsersList).isRequired,
    cdnToken: shapes.modelOf(CDNToken).isRequired,
    tenantName: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    // const { chatgptFeedbackUtility } = props;
    this.defaultSearch = {
      bookId: '',
      userId: '',
      email: '',
      startDateTime: '',
      endDateTime: '',
      type: ''
    };
    this.state = {
      defaultDropdownValue: { title: constants.ALL_BOOKS, bookId: constants.ALL_BOOKS, id: 1 },
      newRequest: true,
      searchFields: '',
      gptResponse: [],
      endDisabled: true,
      isbookIdRequired: false,
      isFeedback: true,
      bookList: [],
      inputValue: '',
      tokenValue: '',
      userIdChecked: false,
      isUserIdExcluded: true,
      isBookmarkFlow: false,
      startDateTimeError: false,
      endDateTimeError: false,
      fromAgenticSelected: false
    };
  }

  componentDidMount = () => {
    const { chatgptFeedbackUtility, mcqSearch } = this.props;
    if (mcqSearch && mcqSearch.data.length > 0) {
      const resData = _.cloneDeep(toJS(mcqSearch.data));
      resData.unshift({ title: constants.ALL_BOOKS, bookId: constants.ALL_BOOKS, id: 1 });
      this.setState({
        bookList: resData,
        searchFields: { bookId: constants.ALL_BOOKS }
      });
    }
    // chatgptFeedbackUtility.fetch();
    /* eslint-disable camelcase */
    this.gptFeedbackResponseHandler = () => {
      const {
        summary,
        quiz,
        discuss,
        chat_enrichment,
        chat_intent,
        content_classifier,
        flashcards,
        topic,
        summary_enrichment,
        summaryTopic,
        quizValidateIntent,
        quizIntent,
        mcq,
        mcqMisconceptions,
        mcqSkillIdentifier,
        mcqQuestionGeneration,
        quizMcq,
        quizFreeResponse,
        freeResponse,
        mcqDistract,
        problemSolve,
        problemSolveRectifier,
        flashCardData,
        commonAuditData
      } = chatgptFeedbackUtility;
      if (chatgptFeedbackUtility) {
        // Safely get current state
        const currentState = this.state;
        if (!currentState) return;
        const { newRequest, gptResponse, bookList } = currentState;
        const summaryData = summary && summary.length > 0 ? summary : [];
        const quizData = quiz && quiz.length > 0 && quiz ? quiz : [];
        const discussData = discuss && discuss.length > 0 && discuss ? discuss : [];
        const chatEnrichmentData = chat_enrichment && chat_enrichment.length > 0 ? chat_enrichment : [];
        const chatIntentData = chat_intent && chat_intent.length > 0 ? chat_intent : [];
        const flashcardsData = flashcards && flashcards.length > 0 ? flashcards : [];
        const topicData = topic && topic.length > 0 ? topic : [];
        const summaryEnrichmentData = summary_enrichment && summary_enrichment.length > 0 ? summary_enrichment : [];
        const summaryTopicData = summaryTopic && summaryTopic.length > 0 ? summaryTopic : [];
        const contentClassifier = content_classifier && content_classifier.length > 0 ? content_classifier : [];
        const quizValidateData = quizValidateIntent && quizValidateIntent.length > 0 ? quizValidateIntent : [];
        const quizIintentData = quizIntent && quizIntent.length > 0 ? quizIntent : [];
        const mcqData = mcq && mcq.length > 0 ? mcq : [];
        const mcqMisconceptionsData = mcqMisconceptions && mcqMisconceptions.length > 0 ? mcqMisconceptions : [];
        const mcqSkillIdentifierData = mcqSkillIdentifier && mcqSkillIdentifier.length > 0 ? mcqSkillIdentifier : [];
        const mcqQuestionGenerationData =
          mcqQuestionGeneration && mcqQuestionGeneration.length > 0 ? mcqQuestionGeneration : [];
        const quizMcqData = quizMcq && quizMcq.length > 0 ? quizMcq : [];
        const quizFreeResponseData = quizFreeResponse && quizFreeResponse.length > 0 ? quizFreeResponse : [];
        const freeResponseData = freeResponse && freeResponse.length > 0 ? freeResponse : [];
        const mcqDistractData = mcqDistract && mcqDistract.length > 0 ? mcqDistract : [];
        const problemSolveData = problemSolve && problemSolve.length > 0 ? problemSolve : [];
        const problemSolveRectifierData =
          problemSolveRectifier && problemSolveRectifier.length > 0 ? problemSolveRectifier : [];
        const flashCardDataArr = flashCardData && flashCardData.length > 0 ? flashCardData : [];
        const comonnFeedbackDataArr = commonAuditData && commonAuditData.length > 0 ? commonAuditData : [];
        const combineData = [
          ...comonnFeedbackDataArr,
          ...flashCardDataArr,
          ...problemSolveData,
          ...problemSolveRectifierData,
          ...summaryData,
          ...discussData,
          ...quizData,
          ...chatEnrichmentData,
          ...chatIntentData,
          ...flashcardsData,
          ...topicData,
          ...contentClassifier,
          ...summaryEnrichmentData,
          ...summaryTopicData,
          ...quizValidateData,
          ...quizIintentData,
          ...mcqData,
          ...mcqMisconceptionsData,
          ...mcqSkillIdentifierData,
          ...mcqQuestionGenerationData,
          ...quizMcqData,
          ...quizFreeResponseData,
          ...freeResponseData,
          ...mcqDistractData
        ];
        bookList.forEach((item) => {
          const alteredValue = item.bookId;
          if (!alteredValue) return;
          combineData.forEach((data, index) => {
            if (data.bookId === alteredValue) {
              combineData[index].title = item.title;
            }
          });
        });
        const getRecordId = (record) =>
          `${record.bookId || ''}_${record.userId || ''}_${record.requestId || ''}_${record.serverDateTime || ''}_${
            record.type || ''
          }`;

        const uniqueNewData = combineData.filter((record, index, self) => {
          const recordId = getRecordId(record);
          return index === self.findIndex((r) => getRecordId(r) === recordId);
        });

        const combineDatatoJS = JSON.parse(JSON.stringify(toJS(uniqueNewData)));
        /* eslint-enable camelcase */
        if (newRequest) {
          const sortedDate = combineDatatoJS.sort((x, y) => new Date(y.serverDateTime) - new Date(x.serverDateTime));
          this.setState({ gptResponse: sortedDate, newRequest: false });
        } else {
          const existingRecordIds = new Set(gptResponse.map(getRecordId));

          const newUniqueRecords = combineDatatoJS.filter((record) => {
            const recordId = getRecordId(record);
            return !existingRecordIds.has(recordId);
          });

          if (newUniqueRecords.length > 0) {
            const combineDataGpt = [...gptResponse, ...newUniqueRecords];
            const sortedDate = combineDataGpt.sort((x, y) => new Date(y.serverDateTime) - new Date(x.serverDateTime));
            this.setState(() => ({ gptResponse: sortedDate }));
          }
        }
      }
    };

    Framework.getEventManager().on(constants.GPT_FEEDBACK_RESPONSE, this.gptFeedbackResponseHandler);
    /* eslint-enable camelcase */
    const urlParams = new URLSearchParams(window.location.search);
    const bookId = urlParams.get('bookId');
    const requestId = urlParams.get('requestId');
    const type = urlParams.get('type');

    if (bookId && requestId && type) {
      this.setState({ isBookmarkFlow: false });
    } else {
      this.setState({ isBookmarkFlow: false });
    }
  };

  componentWillUnmount = () => {
    const { chatgptFeedbackUtility } = this.props;
    chatgptFeedbackUtility.resetApiCallTracking();
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { mcqSearch, internalUsers, cdnToken } = this.props;
    const { tokenValue } = this.state;
    const cdnTokenValue = JSON.parse(JSON.stringify(toJS(cdnToken)));
    const usersData = JSON.parse(JSON.stringify(toJS(internalUsers)));
    const isCDNtokenPresent = utils.getCookieByName('etext-cdn-token');
    if (prevState.tokenValue !== tokenValue) {
      if (_.isEmpty(cdnTokenValue?.name) && !isCDNtokenPresent) {
        this.getCDNTokenData();
      }
      if (mcqSearch && mcqSearch.data.length === 0) {
        this.getBookData();
      }
      if (usersData && usersData?.userId.length === 0) {
        this.getS3InternalUsersList();
      }
    }
  };

  getCDNTokenData = async () => {
    const { tokenValue } = this.state;
    const headers = {
      Authorization: `Bearer ${tokenValue}`
    };
    const response = await axios.get(`${env.EVERGREEN_API_BASE_URL}${constants.GET_CDN_TOKEN_URL}`, { headers });
    if (response && response.data && response.data.data) {
      const cdnTokenVal = response.data.data;
      Framework.getStoreRegistry().getStore('cdnToken').setResponse(cdnTokenVal);
      utils.setCDNTokenInCookie(cdnTokenVal);
    }
  };

  getS3InternalUsersList = async () => {
    const { tokenValue } = this.state;
    const headers = {
      Authorization: `Bearer ${tokenValue}`
    };
    const payload = {
      itemPath: constants.S3_EXCLUDED_USERS_LIST_PATH
    };
    const response = await axios.post(`${env.EVERGREEN_API_BASE_URL}${constants.GET_S3_USERS_LIST_URL}`, payload, {
      headers
    });
    if (response && response.data && response.data.data) {
      Framework.getStoreRegistry().getStore('internalUsers').setResponse(response.data.data[0]);
    }
  };

  getBookData = async () => {
    const { tokenValue } = this.state;
    const headers = {
      Authorization: `Bearer ${tokenValue}`
    };
    const response = await axios.post(`${env.EVERGREEN_API_BASE_URL}${constants.GET_BOOK_DATA_URL}`, {}, { headers });
    if (response && response.data && response.data.data) {
      Framework.getStoreRegistry().getStore('mcqSearch').setResponse(response.data);
      const resData = _.cloneDeep(response.data.data);
      resData.unshift({ title: constants.ALL_BOOKS, bookId: constants.ALL_BOOKS, id: 1 });
      this.setState({
        bookList: resData,
        searchFields: { bookId: constants.ALL_BOOKS }
      });
    }
  };

  onInputChange = (event, newInputValue) => {
    this.setState({
      inputValue: newInputValue
    });
  };

  handleChange = (e) => {
    const { searchFields } = this.state;
    const fieldChanged = {};
    fieldChanged[e.target.name] = e.target.value;
    /* if (e.target.name === constants.TYPE.toLowerCase() && searchFields && searchFields.bookId === constants.ALL_BOOKS) {
      fieldChanged.bookId = '';
      this.setState({ defaultDropdownValue: null, inputValue: '' });
    } */
    if (e.target.name === 'fromAgentic') {
      this.setState({ fromAgenticSelected: e.target.checked });
    }
    this.setState({
      searchFields: { ...searchFields, ...fieldChanged },
      isbookIdRequired: false
    });
  };

  handleDateChange = (date, name) => {
    const { searchFields } = this.state;
    const fieldChanged = {};
    fieldChanged[name] = moment(date).format(constants.MM_DD_YYYY_FORMAT);

    if (date === null && fieldChanged[name] === 'Invalid date') {
      this.setState({
        [`${name}Error`]: false,
        searchFields: { ...searchFields, [name]: '' }
      });
    } else if (fieldChanged[name] === 'Invalid date') {
      this.setState({
        [`${name}Error`]: true,
        /* eslint-disable-next-line no-underscore-dangle */
        searchFields: { ...searchFields, [name]: date._i }
      });
    } else {
      this.setState({
        [`${name}Error`]: false,
        searchFields: { ...searchFields, ...fieldChanged }
      });
    }
    const payload = fieldChanged;
    if (name === 'startDateTime' && payload.startDateTime === 'Invalid date') {
      this.setState({
        endDisabled: true,
        searchFields: { ...searchFields, endDateTime: '' },
        endDateTimeError: false
      });
    } else {
      this.setState({
        endDisabled: false
      });
    }
  };

  handleReset = () => {
    const { chatgptFeedbackUtility } = this.props;
    chatgptFeedbackUtility.resetApiCallTracking();

    this.setState({
      endDisabled: true,
      searchFields: {
        ...this.defaultSearch
      },
      inputValue: '',
      userIdChecked: false,
      gptResponse: [],
      newRequest: true,
      fromAgenticSelected: null
    });
  };

  handleAscending = (dir, value) => {
    const { gptResponse } = this.state;
    if (dir === 'asc') {
      const sorted = [...gptResponse].sort((a, b) =>
        a[value] &&
        b[value] &&
        a[value].toLowerCase().replace(/[^a-z0-9]/g, '') > b[value].toLowerCase().replace(/[^a-z0-9]/g, '')
          ? 1
          : -1
      );
      this.setState({
        ...gptResponse,
        gptResponse: sorted
      });
    } else {
      const sorted = [...gptResponse].sort((a, b) =>
        a[value] &&
        b[value] &&
        a[value].toLowerCase().replace(/[^a-z0-9]/g, '') < b[value].toLowerCase().replace(/[^a-z0-9]/g, '')
          ? 1
          : -1
      );
      this.setState({
        ...gptResponse,
        gptResponse: sorted
      });
    }
  };

  handleExport = async () => {
    const { searchFields } = this.state;
    const payload = { ...searchFields };
    if (payload && (payload.bookId || payload.email || payload.userId || payload.type)) {
      const responseData = await axios({
        timeout: 1000 * 60 * 5,
        method: 'post',
        url: `${env.EVERGREEN_API_BASE_URL}/chatutility/feedback/exportToexcel`,
        responseType: 'blob',
        data: payload
      }).catch((error) => {
        const { response } = error;
        if (response) {
          const { status, data } = response;
          if (status === 500 && data && data.error) {
            const notification = {
              open: true,
              message: data.error.message,
              type: 'error'
            };
            Framework.getStoreRegistry().getStore('notificationState').set(notification);
          }
        } else if (error.message === 'timeout of 60000ms exceeded') {
          const notification = {
            open: true,
            message: error.message,
            type: 'error'
          };
          Framework.getStoreRegistry().getStore('notificationState').set(notification);
        }
      });
      if (responseData && responseData.data) {
        let today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();

        today = `${dd}/${mm}/${yyyy}`;
        const outputFilename = `Chat-utility_Feedback_generated ${today}.csv`;

        const url = URL.createObjectURL(
          // eslint-disable-next-line no-undef
          new Blob([responseData.data], {
            type: responseData.headers['content-type']
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', outputFilename);
        document.body.appendChild(link);
        link.click();
        const notification = {
          open: true,
          message: `${outputFilename} Data Exported Successfully`,
          type: 'success'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else {
      this.setState({ isbookIdRequired: true });
    }
  };

  handleSearch = (customPayload) => {
    const { searchFields, newRequest, startDateTimeError, endDateTimeError, fromAgenticSelected } = this.state;
    const { chatgptFeedbackUtility } = this.props;
    const { summaryNextPageKey, quizNextPageKey, problemSolveNextPageKey, explainNextPageKey } = chatgptFeedbackUtility;
    const bookSearch = { allBookSearch: false };
    if (searchFields.userId) {
      this.setState({ userIdChecked: true });
    } else {
      this.setState({ userIdChecked: false });
    }
    const isNewRequest = !(customPayload && customPayload.lastKey);
    if (startDateTimeError || endDateTimeError) {
      return;
    }
    if (customPayload && customPayload.lastKey) {
      this.setState({ newRequest: false });
    } else {
      if (searchFields?.bookId === constants.ALL_BOOKS) {
        chatgptFeedbackUtility.resetPageNextKey();
      }
      // Clear existing data and set new request flag for fresh search
      this.setState({
        newRequest: true,
        gptResponse: [] // Clear previous data to prevent mixing old and new results
      });
    }
    const payload = { ...searchFields, ...customPayload };
    if (fromAgenticSelected) {
      payload.fromAgentic = true;
    }
    if (payload && payload.bookId === constants.ALL_BOOKS && !payload.type && !payload.email && !payload.userId) {
      const removeEmptyKeys = (objKeys) => {
        let lastKey = {};
        if (objKeys && objKeys.ExclusiveStartKey) {
          const startKey = objKeys.ExclusiveStartKey;
          /* eslint-disable no-param-reassign */
          lastKey = Object.entries(startKey).reduce((obj, [key, value]) => {
            if (key !== null && value !== null) {
              obj[key] = value;
            }
            return obj;
          }, {});
        }
        return { ExclusiveStartKey: lastKey };
      };
      bookSearch.allBookSearch = true;
      chatgptFeedbackUtility.setAllBookSearch(bookSearch);
      const type = searchFields?.type ? searchFields?.type : '';
      const startDateTime = searchFields?.startDateTime ? searchFields.startDateTime : utils.getStartDate24HoursAgo();
      const endDateTime = searchFields?.endDateTime ? searchFields.endDateTime : '';
      const userId = searchFields?.userId ? searchFields.userId : '';
      const email = searchFields?.email ? searchFields.email : '';
      const commonDateDefaultValue = {
        startDateTime,
        endDateTime,
        type,
        email,
        userId,
        ...(fromAgenticSelected && { fromAgentic: true })
      };
      const explainTypeLastKey = explainNextPageKey?.ExclusiveStartKey?.bookId?.S
        ? { lastKey: removeEmptyKeys(explainNextPageKey) }
        : {};
      const summaryTypeLastKey = summaryNextPageKey?.ExclusiveStartKey?.bookId?.S
        ? { lastKey: removeEmptyKeys(summaryNextPageKey) }
        : {};
      const problemSolveTypeLastKey = problemSolveNextPageKey?.ExclusiveStartKey?.bookId?.S
        ? { lastKey: removeEmptyKeys(problemSolveNextPageKey) }
        : {};
      const quizMcqTypeLastKey = quizNextPageKey?.ExclusiveStartKey?.bookId?.S
        ? { lastKey: removeEmptyKeys(quizNextPageKey) }
        : {};
      const apiPayloadOne = {
        ...commonDateDefaultValue,
        type: constants.FEEDBACK_EXPLAIN_TYPE,
        ...explainTypeLastKey
      };
      const apiPayloadTwo = {
        ...commonDateDefaultValue,
        type: constants.FEEDBACK_QUIZ_TYPE,
        ...quizMcqTypeLastKey
      };
      const apiPayloadThree = {
        ...commonDateDefaultValue,
        type: constants.PROBLEM_SOLVE,
        ...problemSolveTypeLastKey
      };
      const apiPayloadFour = {
        ...commonDateDefaultValue,
        type: constants.SUMMARY_TYPE,
        ...summaryTypeLastKey
      };
      if (newRequest || isNewRequest || apiPayloadOne.lastKey) {
        chatgptFeedbackUtility.fetch(apiPayloadOne);
      }
      if (newRequest || isNewRequest || apiPayloadTwo.lastKey) {
        chatgptFeedbackUtility.fetch(apiPayloadTwo);
      }
      if (newRequest || isNewRequest || apiPayloadThree.lastKey) {
        chatgptFeedbackUtility.fetch(apiPayloadThree);
      }
      if (newRequest || isNewRequest || apiPayloadFour.lastKey) {
        chatgptFeedbackUtility.fetch(apiPayloadFour);
      }
    } else if (payload && (payload.bookId || payload.email || payload.userId || payload.type)) {
      chatgptFeedbackUtility.resetPageNextKey();
      bookSearch.allBookSearch = false;
      const { bookId, ...searchPayload } = payload;
      chatgptFeedbackUtility.setAllBookSearch(bookSearch);
      if (bookId === constants.ALL_BOOKS) {
        chatgptFeedbackUtility.fetch(searchPayload);
      } else {
        chatgptFeedbackUtility.fetch(payload);
      }
    } else {
      this.setState({ isbookIdRequired: true });
    }
  };

  onAutoCompleteChange = (event, newValue) => {
    const { searchFields } = this.state;
    this.setState({
      searchFields: {
        ...searchFields,
        bookId: newValue !== null ? newValue.bookId : ''
      },
      isbookIdRequired: false
    });
  };

  setUserId = (field, checkedUserId) => {
    const { searchFields, userIdChecked } = this.state;
    const fieldChanged = {};
    if (userIdChecked) {
      fieldChanged[field] = '';
      this.setState(
        {
          searchFields: { ...searchFields, ...fieldChanged },
          isbookIdRequired: false,
          userIdChecked: false
        },
        () => {
          this.handleSearch();
        }
      );
    } else {
      fieldChanged[field] = checkedUserId;
      this.setState(
        {
          searchFields: { ...searchFields, ...fieldChanged },
          isbookIdRequired: false,
          userIdChecked: true
        },
        () => {
          this.handleSearch();
        }
      );
    }
  };

  handleFilterUserChange = (e) => {
    this.setState({
      isUserIdExcluded: e.target.checked
    });
  };

  render() {
    const {
      classes,
      chatgptUtilityFeedbackStatus,
      chatgptFeedbackUtility,
      chatgptFeedbackUtility: {
        isNextPageKey,
        summaryNextPageKey,
        quizNextPageKey,
        problemSolveNextPageKey,
        explainNextPageKey,
        listOfType,
        isGetAllBookData
      },
      tenantName,
      history
    } = this.props;
    // const { searchFields, endDisabled, gptResponse, pageNumber, loaderStatus } = this.state;
    const {
      isBookmarkFlow,
      searchFields,
      endDisabled,
      gptResponse,
      isFeedback,
      isbookIdRequired,
      bookList,
      inputValue,
      tokenValue,
      userIdChecked,
      defaultDropdownValue,
      isUserIdExcluded,
      startDateTimeError,
      endDateTimeError,
      fromAgenticSelected
    } = this.state;

    const activeSession = utils.getSessionData();
    if (activeSession !== null && tokenValue === '') {
      const token = utils.getToken();
      this.setState({
        tokenValue: token
      });
    }
    const isNextPageKeyEnable = {};
    isNextPageKeyEnable.ExclusiveStartKey = {
      bookId:
        summaryNextPageKey?.ExclusiveStartKey?.bookId?.S ||
        quizNextPageKey?.ExclusiveStartKey?.bookId?.S ||
        problemSolveNextPageKey?.ExclusiveStartKey?.bookId?.S ||
        explainNextPageKey?.ExclusiveStartKey?.bookId?.S
    };
    const typeList = toJS(listOfType);
    return (
      <>
        <Paper>
          <Box sx={{ flexGrow: 1 }}>
            <Box sx={{ p: 2 }}>
              <Typography variant="h5" align="center" gutterBottom spacing={9}>
                {constants.CHAT_CRITERIA_TEXT}
              </Typography>
            </Box>
            <Grid container justifyContent="center">
              {/* <Grid item xs={1} /> */}
              <Grid item xs={11}>
                <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between', p: '0px 33px' }}>
                  <FormControl sx={{ minWidth: '32%', maxWidth: '90%' }} size="small">
                    <AutocompleteComponent
                      options={bookList}
                      onAutoCompleteChange={this.onAutoCompleteChange}
                      onInputChange={this.onInputChange}
                      stateVal={inputValue}
                      errorVal={isbookIdRequired}
                      name="bookId"
                      label="Book Id"
                      componentDefaultValue={defaultDropdownValue}
                    />
                    {isbookIdRequired && (
                      <FormHelperText style={{ color: 'red' }}>Please select any BookId</FormHelperText>
                    )}
                  </FormControl>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <ThemeProvider theme={materialTheme}>
                      <KeyboardDatePicker
                        className={classes.datePicker}
                        format={constants.MM_DD_YYYY_FORMAT}
                        autoOk
                        size="small"
                        variant="inline"
                        inputVariant="outlined"
                        style={{ minWidth: '32%' }}
                        disableFuture
                        value={searchFields.startDateTime || null}
                        label="Start Date"
                        onChange={(date) => this.handleDateChange(date, 'startDateTime')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        helperText={startDateTimeError ? 'Invalid Date Format' : ''}
                        error={startDateTimeError}
                      />
                      <KeyboardDatePicker
                        className={classes.datePicker}
                        // margin="normal"
                        style={{ minWidth: '32%' }}
                        format={constants.MM_DD_YYYY_FORMAT}
                        autoOk
                        variant="inline"
                        size="small"
                        inputVariant="outlined"
                        disableFuture
                        value={searchFields.endDateTime || null}
                        label="End Date"
                        minDate={searchFields.startDateTime || undefined}
                        onChange={(date) => this.handleDateChange(date, 'endDateTime')}
                        disabled={endDisabled}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        helperText={endDateTimeError ? 'Invalid Date Format' : ''}
                        error={endDateTimeError}
                      />
                    </ThemeProvider>
                  </MuiPickersUtilsProvider>
                </Box>
              </Grid>
              {/* <Grid item xs={1} /> */}
            </Grid>
            <br />
            <Grid container direction="row" justifyContent="center">
              {/* <Grid item xs={1} /> */}
              <Grid item xs={11} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  <TextField
                    label={searchFields.userId ? '' : 'User ID'}
                    margin="dense"
                    name="userId"
                    onChange={($event) => this.handleChange($event)}
                    value={searchFields.userId}
                    style={{ minWidth: '32%' }}
                    variant="outlined"
                  />
                  <TextField
                    label="Email ID"
                    margin="dense"
                    // disabled
                    type="email"
                    style={{ minWidth: '32%' }}
                    name="email"
                    onChange={($event) => this.handleChange($event)}
                    value={searchFields.email}
                    variant="outlined"
                  />
                  <FormControl sx={{ mt: 1, width: '32%' }} size="small">
                    <InputLabel id="demo-simple-select-autowidth-label">Type</InputLabel>
                    <Select
                      // autoWidth
                      label="Type"
                      name="type"
                      onChange={($event) => this.handleChange($event)}
                      value={searchFields.type || ''}
                    >
                      <MenuItem disabled value="">
                        <em>{constants.SELECT_PLACEHOLDER_TYPE}</em>
                      </MenuItem>
                      {ChatgptConfig.feedBackTypesDropdownList.map((value) => (
                        <MenuItem value={value.name}>{value.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
              {/* <Grid item xs={1} /> */}
            </Grid>
            <br />
            <div className={chatgptUtilityFeedbackStatus.isPending ? classes.blurStyle : null} />
          </Box>
          <Box>
            <Grid container direction="row" justifyContent="center">
              <FormControl size="small">
                <FormControlLabel
                  control={
                    <Checkbox onChange={this.handleFilterUserChange} name="excludeUserId" checked={isUserIdExcluded} />
                  }
                  style={{
                    alignItems: 'center'
                  }}
                  labelPlacement="end"
                  label="Filter Internal Users"
                />
              </FormControl>
              <FormControl size="small">
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={($event) => this.handleChange($event)}
                      name="fromAgentic"
                      checked={fromAgenticSelected}
                    />
                  }
                  style={{
                    alignItems: 'center'
                  }}
                  labelPlacement="end"
                  label="Agentic"
                />
              </FormControl>
            </Grid>
          </Box>
          <br />
          <Box>
            <Grid container justify="space-evenly" className={classes.buttonGroupStyle}>
              <ThemeProvider theme={themes}>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={() => this.handleSearch()}
                  className={classes.buttonStyle}
                >
                  {constants.CHAT_SEARCH}
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={this.handleReset}
                  className={classes.buttonStyle}
                >
                  {constants.CHAT_RESET}
                </Button>
              </ThemeProvider>
            </Grid>
            <br />
          </Box>
        </Paper>
        <LoadingHandler
          loading={chatgptFeedbackUtility.isCustomLoading || chatgptUtilityFeedbackStatus.isPending}
          isError={
            chatgptUtilityFeedbackStatus.isError &&
            chatgptUtilityFeedbackStatus.error &&
            chatgptUtilityFeedbackStatus.error.status === 401 &&
            chatgptUtilityFeedbackStatus.error.status === 500
          }
          content={
            (gptResponse && gptResponse.length > 0) ||
            (isGetAllBookData && typeList?.length > 0 && gptResponse?.length > 0) ||
            isBookmarkFlow ? (
              <Box>
                <br />
                <ChatDataGrid
                  chatgptUtilityData={gptResponse}
                  handleSearch={this.handleSearch}
                  handleAscending={this.handleAscending}
                  isFeedback={isFeedback}
                  isNextPageKey={isNextPageKey}
                  isNextPageKeyEnable={isNextPageKeyEnable}
                  setUserId={this.setUserId}
                  userIdChecked={userIdChecked}
                  isUserIdExcluded={isUserIdExcluded}
                  history={history}
                  tenantName={tenantName}
                />
              </Box>
            ) : (
              <>
                <br />
                <Paper>
                  <br />
                  <Box>
                    <br />
                    <Typography
                      variant="h4"
                      align="center"
                      gutterBottom
                      spacing={9}
                      className={classes.title}
                      style={{ p: 5, mt: 25 }}
                    >
                      {constants.CHAT_FETCH}
                    </Typography>
                  </Box>
                </Paper>
              </>
            )
          }
          loadingContent={
            <Loader loaderStatus={chatgptFeedbackUtility.isCustomLoading || chatgptUtilityFeedbackStatus.isPending} />
          }
          errorContent={<StateErrorDisplay error={chatgptUtilityFeedbackStatus.error} showDetails />}
        />
      </>
    );
  }
}

export default withStyles(styles)(ChatGptUtilityFeeback);
